export default __webpack_public_path__ + "static/media/order-slip-sample.15301dc0.jpg";